var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 20H12.8125C12.9375 20 13 19.9407 13 19.8222V4.17778C13 4.05926 12.9375 4 12.8125 4H11.1875C11.0625 4 11 4.05926 11 4.17778V19.8222C11 19.9407 11.0625 20 11.1875 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18605 13H19.814C19.938 13 20 12.9375 20 12.8125V11.1875C20 11.0625 19.938 11 19.814 11H4.18605C4.06202 11 4 11.0625 4 11.1875V12.8125C4 12.9375 4.06202 13 4.18605 13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjE4NzUgMjBIMTIuODEyNUMxMi45Mzc1IDIwIDEzIDE5Ljk0MDcgMTMgMTkuODIyMlY0LjE3Nzc4QzEzIDQuMDU5MjYgMTIuOTM3NSA0IDEyLjgxMjUgNEgxMS4xODc1QzExLjA2MjUgNCAxMSA0LjA1OTI2IDExIDQuMTc3NzhWMTkuODIyMkMxMSAxOS45NDA3IDExLjA2MjUgMjAgMTEuMTg3NSAyMFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00LjE4NjA1IDEzSDE5LjgxNEMxOS45MzggMTMgMjAgMTIuOTM3NSAyMCAxMi44MTI1VjExLjE4NzVDMjAgMTEuMDYyNSAxOS45MzggMTEgMTkuODE0IDExSDQuMTg2MDVDNC4wNjIwMiAxMSA0IDExLjA2MjUgNCAxMS4xODc1VjEyLjgxMjVDNCAxMi45Mzc1IDQuMDYyMDIgMTMgNC4xODYwNSAxM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };